import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import _ from 'lodash';

import { Filter, Main } from 'Containers/';
import { withReportSubscription } from 'State/report/withReportSubscription';
import { RECIPE_LISTING_FORM_NAME } from 'Common/FormEnum';
import { RecipeListingFieldEnum as Fields } from 'Common/FieldEnum';
import { withRecipesSubscription } from 'Common/Components/RecipeSearch';
import { withIngredientApi } from 'Pages/managerecipe/components/IngredientTable';
import { IngredientTableModal } from 'Pages/managerecipe/components/IngredientTableModal';
import { createToast, toastType } from 'Common/ToastHelper';

import * as actions from './state/report/actions';
import * as selectors from './state/report/selectors';
import { RecipeListingForm } from './components/RecipeListingForm';

const IngredientTableModalWithApi = withIngredientApi(IngredientTableModal, {
  useSecondaryPaging: true,
});

class RecipeListingContainer extends Component {
  ING_INITIAL_SEARCH_PARAMETERS = Object.freeze({
    Page: 1,
    PageSize: 10,
    Search: '',
    ShowInvLinked: false,
    ShowInactive: false,
  });

  state = {
    searchText: '',
    categoryOption: null,
    sourceOption: null,
    groupOption: null,
    mealComponentOption: null,
    searchItemsOnMenus: false,
    disableHoverOver: false,
    showInactive: false,
    showIngredientModal: false,
    selectedAllergens: [],
    containsSelectedAllergens: true,
    containingIngredient: null,

    ingredientSearchParameters: {
      ...this.ING_INITIAL_SEARCH_PARAMETERS,
    },
  };

  getMainProps = () => {
    const { reportFetching } = this.props;
    return {
      toolbox: {
        formName: RECIPE_LISTING_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: reportFetching,
        },
        shown: true,
      },
    };
  };

  onAddIngredient = (ingredient) => {
    this.props.change(
      RECIPE_LISTING_FORM_NAME,
      Fields.CNCode,
      ingredient.CN_Code
    );
    this.onIngredientModalClose();
    this.handleIngredientChange(null, ingredient.CN_Code);
  };

  componentDidMount() {
    this.searchRecipes();
    this.props.getAllergens();
  }

  componentWillUnmount() {
    this.props.resetRecipeSearch();
  }

  searchRecipes = async () => {
    const { searchRecipes } = this.props;
    const {
      searchText,
      categoryOption,
      sourceOption,
      groupOption,
      mealComponentOption,
      searchItemsOnMenus,
      showInactive,
      selectedAllergens,
      containsSelectedAllergens,
      containingIngredient,
    } = this.state;

    const searchParams = _.pickBy(
      {
        newSearch: true,
        Search: searchText,
        RecipeCategoryId: categoryOption,
        SourceId: sourceOption,
        GroupId: groupOption,
        Component: mealComponentOption,
        SearchItemsOnMenus: searchItemsOnMenus,
        UsePaging: false,
        ShowInactive: showInactive,
        Allergens: selectedAllergens,
        ContainsSelectedAllergens: containsSelectedAllergens,
        ContainingIngredientId: containingIngredient,
      },
      (value) => !_.isNil(value)
    );
    await searchRecipes(searchParams);
  };

  debouncedSearchRecipes = _.debounce(this.searchRecipes, 250);

  onSearchTextChange = (e) => {
    const {
      target: { value },
    } = e;

    this.setState({ searchText: value, page: 0 }, this.debouncedSearchRecipes);
  };

  setToggle = (field) => (e, data) => {
    this.setState({ [field]: data.checked }, this.debouncedSearchRecipes);
  };

  get recipeTableProps() {
    const { searchResults, loadingRecipes, ...rest } = this.props;

    return {
      ...rest,
      data: searchResults,
      loading: loadingRecipes,
      selectable: true,
      disableViewEditDelete: true,
    };
  }

  handleAllergenChange = (e, newValues) => {
    this.setState(
      { selectedAllergens: newValues },
      this.debouncedSearchRecipes
    );
  };

  handlAllergenToggleChange = (e, newValue) => {
    const { selectedAllergens } = this.state;
    if (selectedAllergens.length > 0) {
      this.setState(
        { containsSelectedAllergens: !newValue },
        this.debouncedSearchRecipes
      );
    } else {
      this.setState({ containsSelectedAllergens: !newValue });
    }
  };

  handleIngredientChange = (e, newValue) => {
    this.setState(
      { containingIngredient: newValue },
      this.debouncedSearchRecipes
    );
  };

  handleShowInactiveChange = () => {
    this.setState(
      { showInactive: !this.state.showInactive },
      this.debouncedSearchRecipes
    );
  };

  onIngredientModalClose = () =>
    this.setState({
      showIngredientModal: false,
    });

  handleSearchClick = () => () => {
    this.setState({
      showIngredientModal: true,
      ingredientSearchParameters: {
        ...this.ING_INITIAL_SEARCH_PARAMETERS,
      },
    });
  };

  handleSubmit = (formValues) => {
    if (
      !formValues[Fields.RecipeIds] ||
      (Array.isArray(formValues[Fields.RecipeIds]) &&
        !formValues[Fields.RecipeIds].length)
    ) {
      createToast(
        toastType.error,
        'Error',
        'At least one recipe must be selected',
        true
      );
    } else {
      const { getReport } = this.props;

      const allergenDescriptions = this.getAllergens(
        formValues[Fields.Allergens]
      );

      const model = {
        RecipeIds: formValues.RecipeIds,
        ReportType: formValues.ReportType,
        SortBy: formValues.SortBy,
        ContainingIngredient: formValues.CNCode,
        DoesNotContainAllergen: formValues.DoesNotContainAllergen,
        Allergens: allergenDescriptions,
      };

      getReport('reports/RecipeListingReport', model);
    }
  };

  getAllergens = (allergenIds) => {
    const { allergens } = this.props;

    const allergenDescriptions = [];

    allergens.forEach((allergen) => {
      if (allergenIds.includes(allergen.value)) {
        allergenDescriptions.push(allergen.text);
      }
    });

    return allergenDescriptions;
  };

  onSearchParametersChange = (searchParameters) =>
    this.setState({ ingredientSearchParameters: searchParameters });

  render() {
    const { searchText, allergens } = this.props;
    const { showIngredientModal, ingredientSearchParameters } = this.state;
    return (
      <Fragment>
        <Filter title={'Recipe Listing'} />
        <Main {...this.getMainProps()}>
          <RecipeListingForm
            onSubmit={this.handleSubmit}
            allergenOptions={allergens}
            handleAllergenChange={this.handleAllergenChange}
            handleIngredientChange={this.handleIngredientChange}
            handleShowInactiveChange={this.handleShowInactiveChange}
            handlAllergenToggleChange={this.handlAllergenToggleChange}
            recipeTableProps={this.recipeTableProps}
            searchText={searchText}
            handleSearchClick={this.handleSearchClick}
            onSearchTextChange={this.onSearchTextChange}
            initialValues={{
              [Fields.ReportType]: 0,
              [Fields.SortBy]: 0,
              [Fields.RecipeIds]: [],
              [Fields.Allergens]: [],
            }}
          />
          <IngredientTableModalWithApi
            modalProps={{
              size: 'large',
              open: showIngredientModal,
              onClose: this.onIngredientModalClose,
            }}
            headerTitle={'Select Ingredient'}
            onAddIngredient={this.onAddIngredient}
            searchParameters={ingredientSearchParameters}
            onSearchParametersChange={this.onSearchParametersChange}
            manual={true}
            disableViewEdit={true}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allergens: selectors.getAllergens(state),
  };
};

const mapDispatchToProps = { ...actions, change };

RecipeListingContainer = withReportSubscription(
  withRecipesSubscription(RecipeListingContainer)
);

export const RecipeListing = connect(
  mapStateToProps,
  mapDispatchToProps
)(RecipeListingContainer);



// WEBPACK FOOTER //
// ./src/pages/recipelisting/RecipeListing.js